import { readViteEnv } from "@bindery/shared/env";
import { envSchema } from "./env.schema";

// The logging modules read these raw and fall back on a bad value, so a typo there must not stop the boot.
export const env = readViteEnv(envSchema, import.meta.env, {
  omit: ["VITE_LOG_BACKEND", "VITE_LOG_DEBUG", "VITE_APP_VERSION"],
});
